var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "c-vacancy-page" },
    [
      _c(
        "Container",
        [
          _vm.loading
            ? _c("div", { staticClass: "u-spinner" }, [_vm._v("Loading...")])
            : [
                _c(
                  "Row",
                  [
                    _c(
                      "Column",
                      { attrs: { md: 16 } },
                      [
                        _c(
                          "Heading",
                          { attrs: { level: 1, noMarginTop: "" } },
                          [_vm._v(_vm._s(_vm.model.title))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Row",
                  [
                    _c("Column", { attrs: { md: 16 } }, [
                      _c("div", {
                        staticClass: "c-article-page__main-body",
                        domProps: {
                          innerHTML: _vm._s(
                            this.decodeHtmlEntities(_vm.model.content)
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("Column", { attrs: { offsetMd: 1, md: 4 } }, [
                      _c(
                        "div",
                        { staticClass: "row c-article-page__categories" },
                        [
                          _c("div", { staticClass: "o-col col-xs-24" }, [
                            _c(
                              "div",
                              { staticClass: "o-heading o-heading--category" },
                              [_vm._v("Country")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "o-col col-xs-12 col-md-24" },
                            [_vm._v(_vm._s(_vm.model.DepartmentLabel))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row c-article-page__categories" },
                        [
                          _c("div", { staticClass: "o-col col-xs-24" }, [
                            _c(
                              "div",
                              { staticClass: "o-heading o-heading--category" },
                              [_vm._v("Location")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "o-col col-xs-12 col-md-24" },
                            [_vm._v(_vm._s(_vm.model.location.name))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "o-button c-hero__button o-button--large apply-job-listing",
                          attrs: { href: _vm.model.absolute_url },
                        },
                        [_vm._v("Apply here")]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }